import { useState } from 'react'
import { Copy } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { copyToClipboard } from '@/utils/copyToClipboard'

import { message } from '@/App'
import CommonElement from './CommonElement'
import { chatAction } from '@/store'
import { ChatFileItem } from '@/components/FileItems/doc'

export default function UserContent({ item, isShare }: any) {
  const [isTextCopied, setIsTextCopied] = useState(false)

  const handleCopy = async (content: string) => {
    await copyToClipboard(content)
    if (isTextCopied) return
    chatAction.setInputText(item.text)
    setIsTextCopied(true)
    message.success('复制成功')
    setTimeout(() => {
      setIsTextCopied(false)
    }, 2000)
  }

  return (
    <div className="group overflow-hidden flex flex-col gap-2 items-end">
      <CommonElement item={item} />
      {item.doc && (
        <ChatFileItem
          doc={item.doc}
          preview={true}
          className="bg-white cursor-pointer"
        />
      )}
      {item.text && (
        <>
          <div className="max-w-[80%] rounded-xl px-5 py-3 text-content-first text-sm bg-[#1C1F2308] whitespace-pre-wrap break-all hover:cursor-pointer">
            {item.text}
          </div>
          <Button
            className={`items-center text-sm gap-1 invisible ${
              !isShare && 'group-hover:visible'
            }`}
            variant="custom"
            size="xs"
            onClick={() => handleCopy(item.text)}
          >
            <Copy size={14} />
            复制入框
          </Button>
        </>
      )}
      {!item.text && <div className="h-6" />}
    </div>
  )
}
